module.exports = __webpack_public_path__ + "img/overview.5ec5593f.png";